<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>

    <div class="page_title">项目推荐奖励记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="border-bottom: 1px solid #e8e9f0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="0"
              class="title"
            >全部</el-menu-item>
            <el-menu-item
              index="1"
              class="title"
            >待系统核算</el-menu-item>
            <el-menu-item
              index="2"
              class="title"
            >待结算</el-menu-item>
            <el-menu-item
              index="3"
              class="title"
            >已结算</el-menu-item>
            <el-menu-item
              index="4"
              class="title"
            >已退款</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div>
            <div class="searchbox">
              <div class="item">
                <span>医生姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="doctor_name"
                  style="width: 160px; margin-left: 6px"
                  @input="search"
                ></el-input>
              </div>
              <div class="item">
                <span>手机号</span>
                <el-input
                  placeholder="请输入"
                  v-model="doctor_phone"
                  style="width: 160px; margin-left: 6px"
                  @input="search"
                ></el-input>
              </div>
              <div class="item">
                <span>交易单号</span>
                <el-input
                  placeholder="请输入"
                  v-model="order_sn"
                  style="width: 160px; margin-left: 6px"
                  @input="search"
                ></el-input>
              </div>
              <div class="item">
                <span>支付时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 230px; margin-left: 6px"
                  @change="search"
                ></el-date-picker>
              </div>
              <div class="item">
                <span>项目名称</span>
                <el-input
                  placeholder="请输入"
                  v-model="pro_name"
                  style="width: 160px; margin-left: 6px"
                  @input="search"
                ></el-input>
              </div>
              <div class="item">
                <span>项目类型</span>
                <el-select
                  v-model="pro_type"
                  placeholder="请选择"
                  style="width: 160px; margin-left: 6px"
                  @change="search"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-button
                  type="info"
                  style="
                    background-color: #eceff2;
                    color: #747981;
                    margin-left: 6px;
                  "
                  @click="search"
                >查询</el-button>
              </div>
            </div>

            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  label="支付时间"
                  prop="pay_time"
                ></el-table-column>
                <el-table-column
                  label="项目名称"
                  prop="pro_name"
                ></el-table-column>
                <el-table-column
                  label="销售价格"
                  prop="price"
                ></el-table-column>
                <el-table-column
                  label="推荐奖励"
                  prop="reward_price"
                ></el-table-column>
                <el-table-column label="医生信息">
                  <template slot-scope="scope">
                    <div
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor:pointer"
                    >{{ scope.row.doctor_name }}</div>
                    <div>
                      <span v-if="scope.row.sex == 1">男</span>
                      <span v-if="scope.row.sex == 2">女</span>
                      <span v-if="scope.row.sex == 0">未知</span>
                      <span style="margin-left: 10px">{{
                        scope.row.title
                      }}</span>
                    </div>
                    <div>{{ scope.row.phone }}</div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="结算状态"
                  prop="doc_settlement"
                ></el-table-column>

                <el-table-column
                  label="交易单号"
                  prop="order_sn"
                ></el-table-column>
                <el-table-column
                  label="支付金额"
                  prop="pay_money"
                ></el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.order_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('119')
                          : false
                      "
                    >查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div style="padding: 20px 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doctor_fee from '../../../api/doctor_fee';
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      activeIndex: '0',
      active: '0',
      date: [],
      totalNum: 0,
      doctor_name: '',
      doctor_phone: '',
      order_sn: '',
      pro_name: '',
      pro_type: '',
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      options: [
        {
          label: '体检项目',
          value: 1
        }
      ],
      is_test: 2,
      order_status: 0,
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    handleSelect(key) {
      this.active = Number(key);
      this.order_status = this.active;
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        order_sn: this.order_sn,
        pro_type: this.pro_type,
        pro_name: this.pro_name,
        pay_time_start: '',
        pay_time_end: '',
        order_status: this.order_status,
        is_test: this.is_test
      };
      if (this.date && this.date.length > 0) {
        data.pay_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.pay_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      doctor_fee.getDoctorRewardList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.pay_time = dayjs
              .unix(item.pay_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },

    //查看详情
    toDetail(order_id) {
      this.$router.push({
        path: 'projectdetail',
        query: {
          order_id
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    }
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
.title {
  font-size: 16px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  .item {
    margin-right: 24px;
    margin-top: 24px;
    display: flex;
    align-items: center;
  }
}
</style>
